export function formatCurrencyFormat(price: string, format: string) {
    return format.replace("{price}", price);
}

export type Currency = "THB" | "USD" | "AUD" | "BND" | "EUR" | "KHR" | "CNY" | "GBP" | "HKD" | "IDR" | "JPY" | "LAK" | "MYR" | "MMK" | "PHP" | "SGD" | "TWD" | "VND" | "KRW" | "ILS";

export function convertToSmallestUnit(amount: number, currency: Currency) {
    const currencyUnits = {
      THB: 2, // Thai Baht
      USD: 2, // US Dollar
      AUD: 2, // Australian Dollar
      BND: 2, // Brunei Dollar
      EUR: 2, // Euro
      KHR: 2, // Cambodian Riel
      CNY: 2, // Chinese Yuan
      GBP: 2, // British Pound
      HKD: 2, // Hong Kong Dollar
      IDR: 0, // Indonesian Rupiah
      JPY: 0, // Japanese Yen
      LAK: 2, // Laotian Kip
      MYR: 2, // Malaysian Ringgit
      MMK: 0, // Myanmar Kyat
      PHP: 2, // Philippine Peso
      SGD: 2, // Singapore Dollar
      TWD: 2, // New Taiwan Dollar
      VND: 0, // Vietnamese Dong
      KRW: 0, // South Korean Won
      ILS: 2, // Israeli New Shekel
      // Add other currencies as needed
    };

    let decimals = 0;
    if (currencyUnits.hasOwnProperty(currency)) {
      decimals = currencyUnits[currency];
    }
    const result = Math.round(amount * Math.pow(10, decimals));
    return result;
}